import { useDiorama } from "../../contexts/DioramaContext";

const StepNavigation: React.FC = () => {
	const { state, dispatch } = useDiorama();
	const { currentStep } = state;

	const goToPreviousStep = () => {
		if (currentStep > 1) {
			dispatch({ type: "SET_STEP", step: currentStep - 1 });
		}
	};

	const goToNextStep = () => {
		if (currentStep < 4) {
			dispatch({ type: "SET_STEP", step: currentStep + 1 });
		}
	};

	const isNextDisabled =
		!state.background ||
		currentStep === 4 ||
		(currentStep >= 2 &&
			state.characters.length < state.background?.characters.min);

	return (
		<div className="flex justify-between">
			<button
				type="button"
				onClick={goToPreviousStep}
				disabled={currentStep === 1 || state.characters.length > 0}
				className={`px-4 py-2 rounded ${
					currentStep === 1 || state.characters.length > 0
						? "bg-gray-300 cursor-not-allowed"
						: "cursor-pointer bg-gray-500 text-white hover:bg-gray-600"
				}`}
			>
				Previous
			</button>

			<button
				type="button"
				onClick={goToNextStep}
				disabled={isNextDisabled}
				className={`px-4 py-2 rounded ${
					isNextDisabled
						? "bg-gray-300 cursor-not-allowed"
						: "cursor-pointer bg-amber-600 text-white hover:bg-amber-400"
				}`}
			>
				{currentStep === 3 ? "Finish" : "Next"}
			</button>
		</div>
	);
};

export default StepNavigation;
